import call from "../../../dashboard/service/http";
import constants from "./experienceConstants";
export default {
  state: {
    workexp: [],
    experience: {},
  },
  mutations: {
    SET_EXPERIENCE: (state, payload) => {
      state.workexp = payload;
    },
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    experienceGetters: (state) => (value) => state[value],
  },
  actions: {
    getexperience: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.experience(data))
        .then((res) => {
          commit("MUTATE", { state: "experience", data: res.data.data[0] });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    editexperience: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("patch", constants.editexperience, data)
        .then((res) => {
          Event.$emit("ApiSuccess", res.data.message);
          // back to experience
          Event.$emit("back");
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    submitexperience: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", constants.postexperience, data)
        .then((res) => {
          Event.$emit("ApiSuccess", res.data.message);
          // back to experience
          Event.$emit("back");
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    deleteexperience: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("delete", constants.deleteexperience(data), data)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.message);
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
  },
};
